export enum CardType {
	Red = 0,
	Yellow = 10,
}